import React from 'react';
import { ReactComponent as Boy} from "../Assets/casual-life-3d-boy-sitting-at-the-desk-with-open-book.svg";
import { FaReact, FaBootstrap,FaSass, FaJs, FaLocationArrow } from 'react-icons/fa';
import {FiMail} from 'react-icons/fi';
import { ReactComponent as Tailwind } from '../Assets/tailwind-css.svg';
import { ReactComponent as NextJs } from '../Assets/nextjs.svg';
import { ReactComponent as WhatsApp } from '../Assets/Whatsapp.svg';




const Hero = () => {

  return (
    <div className='min-h-screen flex items-center justify-center text-white relative transition-all duration-700 ease-in-out'>
      <header className="px-4">
            <div className="grid gap-6">
                <div className="grid text-center gap-3">
                    <div className="profile__border p-2">
                            <Boy className='object-fit'/>
                    </div>

                    <h2 className="text-lg sm:text-xl md:text-2xl font-semibold">Williams Godsfavour</h2>
                    <h3 className="">Frontend Engineer</h3>

                    <ul className="flex items-center justify-center gap-3 transition-all duration-800 ease-in-out">
                        <a href="https://github.com/facebook/react" className="cursor-pointer text-[#4338CA]" target="_blank" rel="noreferrer">
                            <FaReact/>
                        </a>

                        <a href="https://bootstrap5.com/" className="cursor-pointer text-[#F2C94C]" target="_blank" rel="noreferrer">
                            <FaBootstrap/>
                        </a>

                        <a href="https://sass-lang.com/" className="cursor-pointer text-[#FF8098]" target="_blank" rel="noreferrer">
                            <FaSass/>
                        </a>

                        <a href="https://www.javascript.com/" className="cursor-pointer text-yellow-300" target="_blank" rel="noreferrer">
                            <FaJs/>
                        </a>
                        
                        <a href="https://tailwindcss.com/" className="cursor-pointer " target="_blank" rel="noreferrer">
                            <Tailwind className='w-6'/>
                        </a>

                        <a href="https://nextjs.org/" className="cursor-pointer " target="_blank" rel="noreferrer">
                            <NextJs className='w-8'/>
                        </a>
                    </ul>
                </div>

                <div className="text-center max-w-lg md:max-w-xl w-full text-xs sm:text-sm md:text-base">
                       Styling the user experience components that meet the requirements of our mocks and fulfill our user stories is my Calling, believes in the power of community.
                </div>

                <div className="gap-5 flex items-center justify-center">
                    <button className="bg-indigo-700 hover:bg-indigo-600 fw-bold text-xs sm:text-sm inline-block text-white p-4 rounded-md flex items-center">
                        Let's Talk <FaLocationArrow className='ml-3'/>
                    </button>

                    <div className="gap-2 flex items-center justify-center">
                        <a href="https://api.whatsapp.com/send?phone=+2348159675934&text=Hello, more information!" target="_blank" rel="noreferrer" className="bg-zinc-700 hover:bg-zinc-600 inline-block text-white p-3.5 rounded-md flex items-center">
                            <WhatsApp/>
                        </a>
                        <a href="mailto:williamsgodsfavoursolomon@gmail.com" target="_blank" rel="noreferrer" className="bg-zinc-700 hover:bg-zinc-600 inline-block text-white p-4 rounded-md flex items-center">
                            <FiMail/>
                        </a>
                    </div>
                </div>
            </div>
        </header>

    </div>
  )
}

export default Hero;